// extracted by mini-css-extract-plugin
export default {"divPrint":"TicketsDavivienda_divPrint__iYYmH"};